<template>
    <v-container fluid class="pb-0">
        <v-row no-gutters class="my-3 justify-center">
            <v-col cols="1">
                <v-btn-primary
                    @click="dialogSelectCompany = !dialogSelectCompany"
                    block
                    data-cy="ClientCompanies-add"
                >
                    {{ $t("shared.add") }}
                </v-btn-primary>
            </v-col>
            <v-col cols="2" v-if="enableWrite" class="pl-2">
                <v-select
                    v-model="accountingFirm.clientUserAccessRight"
                    :items="clientUserAccessRights"
                    item-value="id"
                    label="Mode d'accès"
                    hide-details="auto"
                    data-cy="ClientCompanies-modeAcces"
                    density="compact"
                    item-title="name"
                >
                </v-select>
            </v-col>
            <v-col cols="2" v-if="enableWrite" class="pl-2">
                <v-select
                    v-model="archivedClientCompaniesMode"
                    :items="archivedClientCompaniesOptions"
                    item-value="id"
                    label="Type de dossiers"
                    hide-details="auto"
                    data-cy="ClientCompanies-modeAcces"
                    density="compact"
                    item-title="name"
                >
                </v-select>
            </v-col>
            <v-col cols="2" class="pl-2">
                <v-select
                    v-model="selectedAccontingType"
                    :items="accountingTypes"
                    label="Comptabilité"
                    hide-details
                    elevation="0"
                    data-cy="ClientCompanies-comptabilite"
                    density="compact"
                    item-title="text"
                    clearable
                />
            </v-col>
            <v-col cols="2" class="pl-2">
                <v-autocomplete
                    class="custom-autocomplete"
                    v-model="selectedLegalForm"
                    :items="legalForms"
                    :item-title="formatItemTitle"
                    item-value="id"
                    label="Type de société"
                    data-cy="ClientCompanies-societe"
                    clearable
                />
            </v-col>
            <v-col cols="2" class="pl-2">
                <v-text-field
                    v-model="search"
                    label="Recherche"
                    outlined
                    hide-details
                    data-cy="ClientCompanies-search"
                    density="compact"
                    append-inner-icon="$search"
                    clearable
                    @click:clear="search = ''"
                />
            </v-col>
            <v-col cols="1" class="align-center d-flex justify-space-around">
                <!-- Use "clearable" option instead in attribute you want to "clear" -->
                <!-- <v-tooltip location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn-trash
                            @click="initialize()"
                            class="mx-2"
                            size="small"
                            v-bind="props"
                        />
                    </template>
                    <span>Réinitialiser les filtres</span>
                </v-tooltip> -->
                <v-menu offset-y offset-x v-if="enableWrite">
                    <template v-slot:activator="{ props }">
                        <v-btn-icon icon="$dots_vertical" v-bind="props" />
                    </template>
                    <v-list>
                        <v-list-item
                            @click="importCompaniesDialog = !importCompaniesDialog"
                            :title="`${$t('shared.import')} des dossiers`"
                        >
                            <template v-slot:append>
                                <v-icon icon="$fa-file-import" size="small" />
                            </template>
                        </v-list-item>
                        <v-list-item
                            @click="exportList()"
                            :loading="exportLoading"
                            :title="`${$t('shared.export')} des dossiers`"
                        >
                            <template v-slot:append>
                                <v-icon icon="$fa-file-export" size="small" />
                            </template>
                        </v-list-item>
                        <v-list-item
                            v-if="toCloneCompanies.length"
                            @click="
                                initialize();
                                companyWizardStep = 1;
                                duplicateCompanyDialog = true;
                            "
                            title="Ajouter un exemple"
                        >
                            <template v-slot:append>
                                <v-icon icon="$fa-file-import" size="small" />
                            </template>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
            <!-- <v-col cols="1" class="pl-2">
                <div>
                    <v-btn rounded="circle" size="small" @click="help()" class="ml-3 elevation-0">
                        <v-icon>$fa-question</v-icon>
                    </v-btn>
                </div>
            </v-col> -->
        </v-row>
        <div
            v-if="accountingFirmClients.length && !isArchivedClientCompaniesMode"
            class="d-flex justify-center"
            :style="'max-height:' + maxHeight + ';' + 'overflow:auto'"
        >
            <v-virtual-scroll
                :cols="$vuetify.display.mobile ? '12' : '8'"
                class="my-0 pa-2"
                :items="accountingFirmClients"
            >
                <template v-slot="{ item: comp }">
                    <v-card
                        class="default_card my-2"
                        elevation="0"
                        :disabled="!isAvailableCompany(comp.id)"
                    >
                        <v-row class="d-flex align-center">
                            <v-col
                                cols="2"
                                v-if="!$vuetify.display.mobile"
                                @click="
                                    isAvailableCompany(comp.id)
                                        ? $router.push({ name: 'compa', params: { id: comp.id } })
                                        : ''
                                "
                                class="d-flex align-center justify-center"
                                :disabled="!isAvailableCompany(comp.id)"
                            >
                                <v-icon icon="$apartment" color="green" size="x-large" />
                            </v-col>
                            <v-col
                                :cols="$vuetify.display.mobile ? '10' : '8'"
                                @click="$router.push({ name: 'compa', params: { id: comp.id } })"
                            >
                                <div
                                    data-cy="ClientCompanies-name"
                                    class="d-flex align-center primary--text"
                                >
                                    <span
                                        :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                        style="font-weight: bold; font-size: 16pt"
                                        >{{ comp.name }}</span
                                    >
                                </div>
                                <div class="d-flex align-center">
                                    <span :class="$vuetify.display.mobile ? 'ml-2' : ''">
                                        SIRET: {{ getSiretValue(comp.siret) }}
                                    </span>
                                </div>
                            </v-col>
                            <v-col cols="2" class="d-flex justify-space-around align-center">
                                <v-tooltip
                                    location="bottom"
                                    :disabled="!isAvailableCompany(comp.id)"
                                >
                                    <template v-slot:activator="{ props }">
                                        <ClientCompaniesEditCompanyBtn
                                            v-bind="props"
                                            :company="comp"
                                            :disabled="!isAvailableCompany(comp.id)"
                                        />
                                    </template>
                                    <span>Modifier</span>
                                </v-tooltip>
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <v-btn-icon
                                            v-bind="props"
                                            icon="$oss-duplicate"
                                            color="green"
                                            elevation="0"
                                            :disabled="!isAvailableCompany(comp.id)"
                                            @click="
                                                companyWizardStep = 2;
                                                selectedCompany = comp;
                                                newCompanyName = comp.name + ' (copie)';
                                                duplicateCompanyDialog = true;
                                            "
                                            :data-cy="'ClientCompanies-duplicate-' + comp.id"
                                            size="small"
                                        />
                                    </template>
                                    <span>Dupliquer</span>
                                </v-tooltip>

                                <v-btn-icon
                                    icon="$oss-disconnect"
                                    color="red"
                                    elevation="0"
                                    :disabled="disabledArchiveAction(comp.id)"
                                    @click="
                                        selectedCompany = comp;
                                        dialogArchiveCompany = true;
                                    "
                                    :data-cy="'ClientCompanies-disconnect-' + comp.id"
                                    size="small"
                                    v-tooltip.bottom="
                                        disabledArchiveAction(comp.id)
                                            ? 'Impossible d\'archiver le dossier racine'
                                            : 'Archiver'
                                    "
                                />
                            </v-col>
                        </v-row>
                    </v-card>
                </template>
            </v-virtual-scroll>
        </div>
        <div
            v-else-if="archivedAccountingFirmClients.length && isArchivedClientCompaniesMode"
            class="d-flex justify-center"
            :style="'max-height:' + maxHeight + ';' + 'overflow:auto'"
        >
            <v-virtual-scroll
                :cols="$vuetify.display.mobile ? '12' : '8'"
                class="my-0 pa-2"
                :items="archivedAccountingFirmClients"
            >
                <template v-slot="{ item: archivedAccFirmClient }">
                    <v-card class="default_card my-2" elevation="0">
                        <v-row class="d-flex align-center">
                            <v-col
                                cols="2"
                                v-if="!$vuetify.display.mobile"
                                class="d-flex align-center justify-center"
                                :disabled="!isAvailableCompany(archivedAccFirmClient.clientId)"
                            >
                                <v-icon icon="$apartment" color="green" size="x-large" />
                            </v-col>
                            <v-col
                                :cols="$vuetify.display.mobile ? '10' : '8'"
                                :disabled="!isAvailableCompany(archivedAccFirmClient.clientId)"
                            >
                                <div
                                    data-cy="ClientCompanies-name"
                                    class="d-flex align-center primary--text"
                                >
                                    <span
                                        :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                        style="font-weight: bold; font-size: 16pt"
                                        >{{ archivedAccFirmClient.name }}</span
                                    >
                                </div>
                                <div class="d-flex align-center">
                                    <span :class="$vuetify.display.mobile ? 'ml-2' : ''">
                                        SIRET: {{ getSiretValue(archivedAccFirmClient.siret) }}
                                    </span>
                                </div>
                                <div class="d-flex align-center">
                                    <span :class="$vuetify.display.mobile ? 'ml-2' : ''">
                                        Dossier archivé le:
                                        {{ getArchivingDate(archivedAccFirmClient.archivingDate) }}
                                    </span>
                                </div>
                            </v-col>
                            <v-col cols="2" class="d-flex justify-space-around align-center">
                                <v-tooltip location="bottom" v-if="enableWrite">
                                    <template v-slot:activator="{ props }">
                                        <v-btn-icon
                                            v-bind="props"
                                            icon="$fa-redo"
                                            color="red"
                                            elevation="0"
                                            @click="
                                                selectedCompany = archivedAccFirmClient;
                                                dialogUnArchiveCompany = true;
                                            "
                                            :data-cy="
                                                'ClientCompanies-disconnect-' +
                                                archivedAccFirmClient.id
                                            "
                                            size="small"
                                        />
                                    </template>
                                    <span>Restaurer</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </v-card>
                </template>
            </v-virtual-scroll>
        </div>
        <v-row v-else class="d-flex justify-center">
            <v-col :cols="$vuetify.display.mobile ? '12' : '6'" class="my-0 pa-2">
                <v-card class="default_card ma-0" elevation="0" pa-0 style="margin: 5px">
                    <v-row class="d-flex align-center">
                        <v-col cols="2" v-if="!$vuetify.display.mobile" class="d-flex align-center">
                            <v-icon color="new_red" class="icon" size="x-large" icon="$apartment" />
                        </v-col>
                        <v-col :cols="$vuetify.display.mobile ? '10' : '8'">
                            <div class="d-flex align-center primary--text">
                                <span
                                    :class="$vuetify.display.mobile ? 'ml-2' : ''"
                                    style="font-weight: bold; font-size: 16pt"
                                >
                                    Aucune société cliente
                                </span>
                            </div>
                            <div class="d-flex align-center">
                                <span :class="$vuetify.display.mobile ? 'ml-2' : ''">
                                    Vous n'avez enregistré aucune société cliente
                                </span>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <!-- ThirdPartyCompany -->
        <oss-dialog
            v-model="dialogSelectCompany"
            :title="'Choisir une société'"
            v-if="dialogSelectCompany"
            prefixDataCy="ClientCompanies-valid"
            width="1000px"
        >
            <company-table
                :accountingFirmId="accountingFirm.id"
                :showGenericCompany="false"
                :showNewCompanies="true"
                :showExistingCompanies="false"
                @select-company="companySelected"
                :wizardMode="true"
                :canSelectCompaniesWithAccountingCompany="false"
                data-cy="ClientCompanies-company"
            />
        </oss-dialog>
        <oss-dialog
            v-model="dialogArchiveCompany"
            :max-width="!$vuetify.display.mobile ? '650px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            title="Archiver la société cliente"
            valid-title="Archiver"
            @valid="archiveClientCompany(selectedCompany, false)"
            prefixDataCy="ClientCompanies-disconnectValid"
            style="overflow-y: auto"
        >
            <v-row dense hide-details class="mx-2">
                <v-col>
                    Vous êtes sur le point d'archiver la société
                    <b>{{ selectedCompany.name }}</b> de vos sociétés clientes. Souhaitez-vous
                    laisser les accès aux clients ?
                </v-col>
            </v-row>
            <v-row dense hide-details class="mx-2 pt-2">
                <v-col>
                    <v-radio-group v-model="keepClientUserAccount" inline color="primary">
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-radio v-bind="props" label="Oui" :value="true" />
                            </template>
                            <span>Passera le client sous la supervision de bobbee</span>
                        </v-tooltip>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-radio v-bind="props" label="Non" :value="false" />
                            </template>
                            <span>Désactivera le client définitivement</span>
                        </v-tooltip>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row dense hide-details class="mx-2">
                <v-col> Confirmer le retrait ? </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="dialogUnArchiveCompany"
            :max-width="!$vuetify.display.mobile ? '650px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            title="Restaurer la société cliente"
            valid-title="Restaurer"
            @valid="unArchiveClientCompany(selectedCompany, true)"
            prefixDataCy="ClientCompanies-disconnectValid"
        >
            <v-row dense hide-details class="mx-2">
                <v-col>
                    Vous êtes sur le point de restaurer la société
                    <b>{{ selectedCompany.name }}</b> de vos sociétés clientes.
                </v-col>
            </v-row>
            <v-row dense hide-details class="mx-2 pt-2">
                <!-- <v-col>
                    <v-radio-group v-model="keepClientUserAccount" inline color="primary">
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-radio v-bind="props" label="Oui" :value="true" />
                            </template>
                            <span>Passera le client sous la supervision de bobbee</span>
                        </v-tooltip>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-radio v-bind="props" label="Non" :value="false" />
                            </template>
                            <span>Désactivera le client définitivement</span>
                        </v-tooltip>
                    </v-radio-group>
                </v-col> -->
            </v-row>
            <v-row dense hide-details class="mx-2">
                <v-col> Confirmer la restauration ? </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="duplicateCompanyDialog"
            :max-width="!$vuetify.display.mobile ? '650px' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            title="Dupliquer la société cliente"
            valid-title="Dupliquer"
            @valid="duplicateCompany()"
            :validDisabled="!selectedCompany || !selectedCompany.id"
            :validLoading="duplicateCompanyLoading"
            prefixDataCy="ClientCompanies-duplicateValid"
        >
            <v-window v-model="companyWizardStep" touchless>
                <v-window-item :value="1">
                    <v-list subheader lines="two">
                        <v-list-item
                            v-for="(company, i) in toCloneCompanies"
                            :key="i"
                            :class="getCompanyClass(company.id)"
                            @click="selectCompanyToClone(company)"
                            :data-cy="'selectUser-user-' + i"
                            class="oss-list-item-xl"
                        >
                            <!-- <template class="my-0" color="primary">
                                    <span class="white--text headline">{{getUserBigram(user)}}</span>
                                </template> -->
                            <v-list-item-title>
                                {{ company.name }}
                            </v-list-item-title>
                            <v-list-item-subtitle v-if="company.siret">{{
                                company.siret
                            }}</v-list-item-subtitle>

                            <template v-slot:append class="my-0">
                                <v-btn-icon
                                    color="primary"
                                    :icon="
                                        company.id === selectedCompany.id
                                            ? '$radio_button_checked'
                                            : '$radio_button_unchecked'
                                    "
                                />
                            </template>
                        </v-list-item>
                    </v-list>
                </v-window-item>
                <v-window-item :value="2">
                    <v-row class="mx-2">
                        <v-col>
                            Vous êtes sur le point de dupliquer la société
                            <b>{{ selectedCompany.name }}</b
                            >. Confirmer la duplication ?
                        </v-col>
                    </v-row>
                    <v-row class="mx-2">
                        <v-col>
                            <v-text-field-filled
                                v-model="newCompanyName"
                                label="Nom de la nouvelle société"
                                hide-details
                                density="compact"
                            />
                        </v-col>
                    </v-row>
                </v-window-item>
            </v-window>
        </oss-dialog>
        <oss-dialog
            v-model="newCompanyDialog"
            :max-width="!$vuetify.display.mobile ? '100%' : undefined"
            :fullscreen="$vuetify.display.mobile"
            :hide-overlay="$vuetify.display.mobile"
            :actions="actions"
            title="Edition | Création de la société"
            prefixDataCy="ClientCompanies-valid"
        >
            <div class="d-flex flex-row">
                <EditCompany
                    :settingsMode="true"
                    :adminMode="true"
                    :inCompany="newCompany"
                    :actions="actions"
                    @updated="addCompany"
                    class="w-100"
                />
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="importCompaniesDialog"
            title="Importer des dossier"
            valid-title="Importer"
            :actions="importActions"
            width="60vw"
        >
            <CompaniesImport
                v-if="importCompaniesDialog"
                ref="importComponent"
                :actions="importActions"
                :documentType="'CLIENT_COMPANIES'"
                :accountingFirmId="accountingFirm.id"
                @documentImported="onDocumentImported()"
            />
        </oss-dialog>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import gql from "graphql-tag";
import axios from "axios";
import _ from "lodash";
import { Apollo } from "@/decorators";
import { User } from "../../store/store";

import { Company } from "../../../../types";

import UPDATE_CLIENT_COMPANIES from "../../graphql/company/UpdateCompanyClientCompanies.gql";
import GET_ARCHIVED_COMPANIES from "../../graphql/company/GetArchivingCompanyClientCompanies.gql";
import UNARCHIVE_CLIENT_COMPANIES from "../../graphql/company/UnArchiveCompanyClientCompanies.gql";
import DUPLICATE_COMPANY from "../../graphql/company/DuplicateCompany.gql";
import TO_CLONE_COMPANIES from "../../graphql/company/ToCloneCompanies.gql";

import CompanyTableComponent from "../admin/CompaniesTable.vue";
import CompaniesImport from "../import/CompaniesImport.vue";
import ClientCompaniesEditCompanyBtn from "./ClientCompaniesEditCompanyBtn.vue";

import { DialogAction } from "../../services/dialogAction";
import EditCompany from "../EditCompany.vue";

import { getSiretValue } from "../../../src/services/companyServices";
import getEnv from "../../env";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import emitter from "@/services/emitter";

const env = getEnv();

const BobbeeImg = require("../../assets/img/bobbee3d/bobbee3dTuto.png");

// Déclaration de l'interface
interface LegalForm {
    id: string;
    name: string;
}

@Component({
    components: {
        companyTable: CompanyTableComponent,
        EditCompany,
        CompaniesImport,
        ClientCompaniesEditCompanyBtn,
    },
    emits: ["refresh"],
})
export class ClientCompanies extends Vue {
    newCompanyName: string = "";
    selectedLegalForm: string = "";
    selectedAccontingType: string = "";
    keepClientUserAccount: boolean = false;

    legalForms: LegalForm[] = [
        { id: "ASSO", name: "Association" },
        { id: "CE", name: "Comité d'entreprise" },
        { id: "CL", name: "Collectivité locale" },
        { id: "CNE", name: "Commune" },
        { id: "COOP", name: "Coopérative" },
        { id: "CUMA", name: "Coopérative d'utilisation de matériel agricole" },
        { id: "DPT", name: "Département" },
        { id: "EARL", name: "Exploitation agricole à responsabilité limitée" },
        { id: "EC", name: "Entreprise collective" },
        { id: "EI", name: "Entreprise individuelle" },
        { id: "EIRL", name: "Entreprise individuelle à responsabilité limitée" },
        { id: "ETRANGER", name: "Personne morale de droit étranger" },
        { id: "EURL", name: "Entreprise unipersonnelle à responsabilité limitée" },
        { id: "FEDE", name: "Fédération" },
        { id: "FOND", name: "Fondation" },
        { id: "GAEC", name: "Groupement agricole d'exploitation en commun" },
        { id: "GEIE", name: "Groupement européen d'intérêt économique" },
        { id: "GF", name: "Groupement forestier" },
        { id: "GFA", name: "Groupement foncier agricole" },
        { id: "GFR", name: "Groupement foncier rural" },
        { id: "GIE", name: "Groupement d'intérêt économique" },
        { id: "GPT", name: "Groupement" },
        { id: "GREFFE", name: "Greffe" },
        { id: "IND", name: "Indivision" },
        { id: "MUT", name: "Mutuelle" },
        { id: "SA", name: "Société anonyme" },
        { id: "SAE", name: "Société anonyme d'exploitation" },
        { id: "SARL", name: "Société à responsabilité limitée" },
        { id: "SELARL", name: "Société d'exercice libéral à responsabilité limitée" },
        { id: "SAS", name: "Société anonyme par actions simplifiée" },
        { id: "SASU", name: "SASU" },
        { id: "SC", name: "Société civile (autre que infra)" },
        { id: "SCA", name: "Société en commandite par actions" },
        { id: "SCCV", name: "Société civile de construction vente" },
        { id: "SCE", name: "Société civile d'exploitation" },
        { id: "SCEA", name: "Société civile d'exploitation agricole" },
        { id: "SCEV", name: "Société civile d'exploitation vinicole" },
        { id: "SCH", name: "Société civile holding" },
        { id: "SCI", name: "Société civile immobilière" },
        { id: "SCM", name: "Société civile de moyens" },
        { id: "SCP", name: "Société civile professionnelle" },
        { id: "SCPG", name: "Société civile participation gestion" },
        { id: "SCPI", name: "Société civile de placement collectif immobilier" },
        { id: "SCS", name: "Société en commandite simple" },
        { id: "SCVV", name: "Société civile de vente volontaire" },
        { id: "SDE", name: "Société de droit étranger" },
        { id: "SNC", name: "Société en nom collectif" },
    ];

    clientUserAccessRights: any = [
        { id: "AVAILABLE_COMPANY", name: "Selection de dossiers" },
        { id: "AVAILABLE_WORKSPACE", name: "Groupes de dossiers" },
    ];

    archivedClientCompaniesOptions: any = [
        { id: false, name: "Dossiers actifs" },
        { id: true, name: "Dossiers archivés" },
    ];

    accountingTypes: any = [
        {
            value: "RECEIVABLES_DEBT",
            text: "Comptabilité d'engagement",
        },
        {
            value: "INCOMING_OUTGOING_PAYMENT",
            text: "Comptabilité de trésorerie",
        },
    ];

    dialogSelectCompany: boolean = false;

    importCompaniesDialog: boolean = false;

    getExistingCompanies: boolean = false;

    verifLoading: boolean = false;

    loadingValidate: boolean = false;

    newCompany: any = {
        text: "",
    };

    actions: any = {
        action: new DialogAction(),
    };

    importActions = {
        action: new DialogAction(),
    };

    dialogArchiveCompany: boolean = false;
    dialogUnArchiveCompany: boolean = false;
    newCompanyDialog: boolean = false;

    duplicateCompanyDialog: boolean = false;
    duplicateCompanyLoading: boolean = false;

    companyWizardStep = 1;

    selectedCompany: any = {
        id: "",
        siret: null,
        text: null,
    };

    newCompanyText = "";

    companiesHeaders: Array<any> = [
        { text: "", value: "" },
        { text: "Nom", value: "date" },
        { text: "Siret", value: "amount" },
    ];

    search = "";

    archivedClientCompaniesMode = false;

    get currentUser(): User {
        return this.$store.state.user;
    }

    get accountingFirm() {
        return this.$store.state.user.company;
    }

    get isAccountingEmployee() {
        return this.currentUser.isAccountingEmployee;
    }

    get enableWrite() {
        return true;
    }

    get maxHeight() {
        const innHeight = window.innerHeight;
        const vhHeight = (190 / innHeight) * 100;
        const maxHeight_vh = 100 - vhHeight;

        return maxHeight_vh + "vh";
    }

    get accountingFirmClients() {
        let array: any = [];
        const clientCompanies = !this.isAccountingEmployee
            ? this.clientCompanies
            : this.currentUser.allAvailableCompanies;
        let clients = clientCompanies.sort((a: any, b: any) => a.name.localeCompare(b.name));
        if (this.search) {
            const lSearch = this.search.toLowerCase();
            for (const client of clients) {
                if (client.name && client.name.toLowerCase().indexOf(lSearch) !== -1) {
                    array.push(client);
                } else if (client.siret && client.siret.indexOf(lSearch) !== -1) {
                    array.push(client);
                }
            }
            clients = array;
            array = [];
        }
        if (this.selectedLegalForm) {
            for (let i = 0; i < clients.length; i++) {
                if (clients[i].legalForm) {
                    if (clients[i].legalForm === this.selectedLegalForm) {
                        array.push(clients[i]);
                    }
                }
            }
            clients = array;
            array = [];
        }

        if (this.selectedAccontingType) {
            for (let i = 0; i < clients.length; i++) {
                if (clients[i].profile) {
                    if (clients[i].profile.accountingType) {
                        if (clients[i].profile.accountingType === this.selectedAccontingType) {
                            array.push(clients[i]);
                        }
                    }
                }
            }
            clients = array;
        }
        return clients.sort((a: any, b: any) => a.name.localeCompare(b.name));
    }

    get archivedAccountingFirmClients() {
        let array: any = [];
        const archivedAccountingFirmClients = this.archivedClientCompanies;

        if (!archivedAccountingFirmClients) {
            return [];
        }

        let archivedClients = archivedAccountingFirmClients.sort((a: any, b: any) =>
            a.name.localeCompare(b.name),
        );
        if (this.search) {
            const lSearch = this.search.toLowerCase();
            for (const client of archivedClients) {
                if (client.name && client.name.toLowerCase().indexOf(lSearch) !== -1) {
                    array.push(client);
                } else if (client.siret && client.siret.indexOf(lSearch) !== -1) {
                    array.push(client);
                }
            }
            archivedClients = array;
            array = [];
        }
        if (this.selectedLegalForm) {
            for (let i = 0; i < archivedClients.length; i++) {
                if (archivedClients[i].legalForm) {
                    if (archivedClients[i].legalForm === this.selectedLegalForm) {
                        array.push(archivedClients[i]);
                    }
                }
            }
            archivedClients = array;
            array = [];
        }

        if (this.selectedAccontingType) {
            for (let i = 0; i < archivedClients.length; i++) {
                if (archivedClients[i].profile) {
                    if (archivedClients[i].profile.accountingType) {
                        if (
                            archivedClients[i].profile.accountingType === this.selectedAccontingType
                        ) {
                            array.push(archivedClients[i]);
                        }
                    }
                }
            }
            archivedClients = array;
        }
        debugger;
        return archivedClients.sort((a: any, b: any) => a.name.localeCompare(b.name));
    }

    get isArchivedClientCompaniesMode() {
        if (this.archivedClientCompaniesMode) {
            return true;
        }
        return false;
    }

    initialize() {
        this.selectedCompany = {
            id: "",
            siret: null,
            name: null,
        };
        this.newCompanyName = "";
        this.search = "";
        this.selectedLegalForm = "";
        this.selectedCompany = "";
        this.selectedAccontingType = "";
    }

    beforeMount() {
        this.initialize();
    }

    @Apollo({
        query: gql`
            query companyDetails($id: ID!) {
                company(where: { id: $id }) {
                    id
                    clientCompanies {
                        id
                        name
                        siret
                        profile {
                            id
                            accountingType
                        }
                        legalForm
                    }
                }
            }
        `,
        variables() {
            return {
                id: this.accountingFirm.id,
            };
        },
        skip() {
            return (
                this.isAccountingEmployee ||
                !this.accountingFirm ||
                !this.accountingFirm.id ||
                this.isArchivedClientCompaniesMode
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.company) {
                    if (data.company.clientCompanies) {
                        this.clientCompanies = data.company.clientCompanies;
                    } else {
                        this.clientCompanies = [];
                    }
                }
            }
        },
    })
    clientCompanies = [];

    @Apollo({
        query() {
            return GET_ARCHIVED_COMPANIES;
        },
        fetchPolicy: "network-only",
        variables() {
            return {
                accountingFirmId: this.accountingFirm.id,
            };
        },
        skip() {
            return this.isAccountingEmployee || !this.accountingFirm || !this.accountingFirm.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.getArchivingCompanyClientCompanies?.length) {
                    this.archivedClientCompanies = data.getArchivingCompanyClientCompanies;
                } else {
                    this.archivedClientCompanies = [];
                }
            }
        },
    })
    archivedClientCompanies = [];

    @Apollo({
        query: TO_CLONE_COMPANIES,
        fetchPolicy: "network-only",
        debounce: 500,
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                if (data.companyFirst) {
                    this.toCloneCompanies = data.companyFirst.clientCompanies;
                    // this.toCloneCompanies.push(
                    //     {
                    //         id:"ckjjr4sjyc9p207062asayil0",
                    //         siret:"44243330600028",
                    //         name:"Mme BARNABA Muriel"
                    //     })
                } else {
                    this.toCloneCompanies = [];
                }
            }
        },
    })
    toCloneCompanies = [];

    selectCompanyToClone(company: { name: string }) {
        this.selectedCompany = company;
        this.newCompanyName = company.name + " (copie)";
        this.companyWizardStep = 2;
    }

    async companySelected(obj: Company) {
        this.newCompany = { ...obj };
        this.newCompanyDialog = true;
        this.dialogSelectCompany = false;
    }

    async addCompany(obj: Company) {
        if (obj.id) {
            this.actions.action.loading = true;
            const existingCompany = this.accountingFirmClients.find(
                (cc: { id: string }) => cc.id === obj.id,
            );
            if (existingCompany) {
                if (!(existingCompany as any).selected) {
                    (existingCompany as any).selected = true;
                    await this.archiveClientCompany(existingCompany, true);
                }
            } else {
                (obj as any).selected = true;
                this.accountingFirmClients.push(obj);
                await this.archiveClientCompany(obj, true);
            }
            this.newCompanyDialog = false;
        }
        // } else {
        // this.newCompany = { ...obj }
        // this.newCompanyDialog = true
        // }
        this.dialogSelectCompany = false;
        this.actions.action.loading = false;
    }

    async archiveClientCompany(obj: Company, connect: boolean) {
        if (this.accountingFirm.id) {
            const disconnectClientCompanies = [];
            const connectClientCompanies = [];
            // console.log(obj)
            if (connect) {
                connectClientCompanies.push(obj.id);
            } else {
                disconnectClientCompanies.push(obj.id);
            }
            await this.$apollo.mutate({
                mutation: UPDATE_CLIENT_COMPANIES,
                variables: {
                    id: this.accountingFirm.id,
                    disconnectClientCompanies: disconnectClientCompanies,
                    connectClientCompanies: connectClientCompanies,
                    keepClientUserAccount: this.keepClientUserAccount,
                },
            });
            this.dialogArchiveCompany = false;
            await this.$apollo.queries.archivedClientCompanies.refetch();
            this.$emit("refresh");
        }
    }

    async unArchiveClientCompany(obj, connect: boolean) {
        debugger;
        if (this.accountingFirm.id) {
            const connectClientCompanies = [];
            // console.log(obj)
            if (connect) {
                connectClientCompanies.push(obj.clientId);
            }
            await this.$apollo.mutate({
                mutation: UNARCHIVE_CLIENT_COMPANIES,
                variables: {
                    id: this.accountingFirm.id,
                    connectClientCompanies: connectClientCompanies,
                },
            });
            this.dialogUnArchiveCompany = false;
            await this.$apollo.queries.archivedClientCompanies.refetch();
            this.$emit("refresh");
        }
    }

    async duplicateCompany() {
        if (this.accountingFirm.id && this.selectedCompany && this.selectedCompany.id) {
            this.duplicateCompanyLoading = true;
            const result = await this.$apollo.mutate({
                mutation: DUPLICATE_COMPANY,
                variables: {
                    id: this.selectedCompany.id,
                    name: this.newCompanyName,
                    accountingFirmId: this.accountingFirm.id,
                },
            });
            this.duplicateCompanyDialog = false;
            this.duplicateCompanyLoading = false;
            this.$emit("refresh");
        } else {
            debugger;
        }
    }

    exportLoading: boolean = false;
    stepData = null;

    async exportList() {
        this.exportLoading = true;
        const result = await axios.get(
            `${env.VUE_APP_BACKEND}/clientCompanies/download/${
                this.accountingFirm.id
            }/xlsx?dt="${new Date().getTime()}`,
            {},
        );
        if (result.status === 200) {
            this.exportLoading = false;
        }
        window.open(result.data, "_blank");
    }

    help() {
        document.location.href = "http://bit.ly/2Zo5ZY6";
    }

    getCompanyClass(id: any) {
        let companyClass = "oss-list-item mb-2";
        if (id === this.selectedCompany.id) companyClass += " oss-list-item-selected";
        return companyClass;
    }

    startTuto() {
        emitter.$emit("setTutorialData", [
            {
                ref: null,
                title: "Tuto vidéo",
                pages: [
                    {
                        text: "La validation des factures se fait en plusieurs étapes.",
                        img: BobbeeImg,
                        video: "https://bobbee-videos.s3.eu-central-1.amazonaws.com/gi-creation-client.mp4",
                        outed: true,
                    },
                ],
            },
        ]);
    }

    onDocumentImported() {
        this.importCompaniesDialog = false;
        this.loadingValidate = false;
        this.$emit("refresh");
    }

    getSiretValue(siret: string) {
        return getSiretValue(siret);
    }

    getArchivingDate(date: string) {
        if (date) {
            return moment(date).format("DD/MM/YYYY");
        }
    }

    @Watch("accountingFirm.clientUserAccessRight")
    async updateClientUserAccessRight() {
        if (this.accountingFirm?.id) {
            await this.$apollo.mutate({
                mutation: gql`
                    mutation UpdateClientUserAccessRight(
                        $accountingFirmId: ID!
                        $clientUserAccessRight: CompanyClientUserAccessRight!
                    ) {
                        updateCompany(
                            where: { id: $accountingFirmId }
                            data: { clientUserAccessRight: $clientUserAccessRight }
                        ) {
                            id
                        }
                    }
                `,
                variables: {
                    accountingFirmId: this.accountingFirm.id,
                    clientUserAccessRight: this.accountingFirm.clientUserAccessRight,
                },
            });
        }
    }

    isAvailableCompany(companyId: string) {
        if (this.currentUser.isRoot) {
            return true;
        }
        return this.currentUser.allAvailableCompanies.some(
            (company: any) => company.id === companyId,
        );
    }

    disabledArchiveAction(companyId: string) {
        debugger;
        if (!this.isAvailableCompany(companyId)) {
            return true;
        }
        if (companyId === this.accountingFirm?.id) {
            return true;
        }
        return false;
    }

    formatItemTitle(item: { id: string; name: string }) {
        if (!item.id && !item.name) {
            return "";
        } else {
            return `${item.id} - ${item.name}`;
        }
    }
}

export default toNative(ClientCompanies);
</script>

<style scoped lang="scss">
.error,
.warning {
    color: #fff;
}
</style>
